import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import VendorSearch from '../../search/VendorSearch';

export default function FormInputVendorSearch(props) {
  return <FormInputSearch {...props} searchComponent={VendorSearch} />;
}
